import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as common from '../../common'

export type Term = common.Identified<Term.Id> &
  common.Named &
  common.Described.Optionally

export namespace Term {
  export const isTerm: TypeChecker<Term> = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.intersection(
      common.Named.isNamed,
      common.Described.Optionally.isOptionally,
      common.Identified.getTypeChecker(Id.isId),
    ),
  )

  export type Id = number
  export namespace Id {
    export const isId: TypeChecker<Id> = TypeChecker.isNumber
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  export type Input = Omit<Term, 'id'>
  export namespace Input {
    export const isInput: TypeChecker<Input> = TypeChecker.Factory.lazy(() =>
      TypeChecker.Factory.omit(Term.isTerm, ['id']),
    )
  }

  export type Updates = Partial<Input>
  export namespace Updates {
    // TODO: fix below because it causes front-end build to fail, since
    // front-end build doesn't use strict typescript mode
    // export const isUpdates: TypeChecker<Updates> = TypeChecker.Factory.lazy(
    //   () =>
    //     TypeChecker.Factory.intersection(
    //       TypeChecker.Factory.omit(Input.isInput, [
    //         'name',
    //       ] satisfies (keyof Difference<Updates, Input>)[]),
    //       TypeChecker.Factory.object<Difference<Updates, Input>>({
    //         name: TypeChecker.Factory.optional(TypeChecker.isString),
    //       }),
    //     ),
    // )
  }
}
